import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Grid, TAGCard, TermsAndConditions } from '../..';

var Card = function Card(_ref) {
  var _card$description, _card$image$file$url, _card$image, _card$tc;

  var branding = _ref.branding,
      card = _ref.card,
      eyebrowColor = _ref.eyebrowColor,
      eyebrowSx = _ref.eyebrowSx,
      _ref$allCards = _ref.allCards,
      allCards = _ref$allCards === void 0 ? [] : _ref$allCards,
      eyebrowTextTransform = _ref.eyebrowTextTransform,
      _ref$eyebrowVariant = _ref.eyebrowVariant,
      eyebrowVariant = _ref$eyebrowVariant === void 0 ? 'bodyMediumBook' : _ref$eyebrowVariant,
      _ref$itemStacked = _ref.itemStacked,
      itemStacked = _ref$itemStacked === void 0 ? false : _ref$itemStacked,
      roundedImage = _ref.roundedImage;
  return React.createElement(Grid, {
    item: true,
    columnSpacing: 2,
    sx: {
      height: '100%',
      padding: {
        xs: '0px',
        md: '0px'
      }
    }
  }, React.createElement(TAGCard, {
    theme: "BigImageOnTopButtons",
    cardTitle: card.title,
    description: card === null || card === void 0 ? void 0 : (_card$description = card.description) === null || _card$description === void 0 ? void 0 : _card$description.description,
    richTextDescription: card.richTextDescription,
    branding: branding,
    imagePath: (_card$image$file$url = (_card$image = card.image) === null || _card$image === void 0 ? void 0 : _card$image.file.url) !== null && _card$image$file$url !== void 0 ? _card$image$file$url : '',
    buttonText: card.buttonText,
    buttonUrl: card.buttonUrl,
    eyebrow: card.eyebrow,
    focalPointImage: card.focalPointImage,
    tc: (_card$tc = card.tc) !== null && _card$tc !== void 0 && _card$tc.tcText ? React.createElement(TermsAndConditions, _objectSpread(_objectSpread({}, card.tc), {}, {
      branding: branding
    })) : null,
    allCards: allCards.length ? allCards : [card],
    eyebrowColor: eyebrowColor,
    eyebrowTextTransform: eyebrowTextTransform,
    eyebrowVariant: eyebrowVariant,
    buttonIcon: card.buttonIcon,
    buttonIconPosition: card.buttonIconPosition,
    eyebrowSx: eyebrowSx,
    showBorder: card.showBorder,
    showCardShadow: card.showCardShadow,
    backgroundColor: card.backgroundColor,
    cardTextAlignment: card.cardTextAlignment,
    sx: {
      padding: {
        md: '0px',
        sm: "0 ".concat(itemStacked ? 0 : '10px', " 0 0"),
        xs: "0 ".concat(itemStacked ? 0 : '10px', " 0 0")
      },
      height: '100%',
      display: 'flex',
      alignContent: 'stretch',
      '.MuiPaper-root': !roundedImage ? {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      } : {}
    }
  }));
};

export default Card;